module.exports = __webpack_public_path__ + "img/map-person1.e9fcd6a5.png";